import { render } from "./BenComTools.vue?vue&type=template&id=2fa47502"
import script from "./BenComTools.vue?vue&type=script&lang=js"
export * from "./BenComTools.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/benComms/BenComTools.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2fa47502"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2fa47502', __exports__)) {
    api.reload('2fa47502', __exports__)
  }
  
  module.hot.accept("./BenComTools.vue?vue&type=template&id=2fa47502", () => {
    api.rerender('2fa47502', render)
  })

}


export default __exports__